import { useAtom } from "jotai";
import {
  _FeeAtom,
  ExtraIncomeAtomsAtom,
  ExtraIncomesAtom,
  MembersAtom
} from "./atoms";
import * as React from "react";
import { ExtraField } from "./extraField";
import NumberFormat from "react-number-format";
import { Tooltip } from "@reach/tooltip";
import "@reach/tooltip/styles.css";
import * as strings from "./strings";
import { positionTooltipRight } from "./positionTooltipRight";
import { useNav } from "./useNav";

const {
  back_string,
  next_string,
  step2_addextra_string,
  step2_feeperyear,
  step2_intro,
  step2_membercount,
  step2_title,
  step2_bottom_text
} = strings;

let tooltipStyle = {
  background: "hsla(0, 0%, 0%, 0.75)",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "0.5em 1em"
};

export function Label(props: {
  label: string;
  description: string;
  tooltip: string;
}) {
  // noinspection RequiredAttributes
  return (
    <div className="atc-label">
      <span className="atc-label__title">
        {props.label}
        {props.tooltip ? (
          <Tooltip
            label={props.tooltip}
            style={tooltipStyle}
            position={positionTooltipRight}
          >
            <span className="at-tooltip" />
          </Tooltip>
        ) : null}
      </span>
      <span className="atc-label__text">{props.description}</span>
    </div>
  );
}

export function Step2() {
  const { prev, next } = useNav();
  const [fee, setFee] = useAtom(_FeeAtom);
  const [members, setMembers] = useAtom(MembersAtom);
  const [extraFieldAtoms, removeExtraField] = useAtom(ExtraIncomeAtomsAtom);
  const [, setExtraFields] = useAtom(ExtraIncomesAtom);

  return (
    <>
      <div className="atc-step-header">
        <p className="at-tagline">Step 2 / 4</p>
        <h2 className="at-title">{step2_title}</h2>
        <div
          className="at-text"
          dangerouslySetInnerHTML={{ __html: step2_intro }}
        />
      </div>

      <div className="atc-row">
        <Label
          label={step2_membercount.label}
          description={step2_membercount.description}
          tooltip={step2_membercount.tooltip}
        />
        <NumberFormat
          className="at-input at-input--border"
          thousandSeparator={"."}
          decimalSeparator={","}
          value={members}
          onValueChange={values => {
            const { value } = values;
            setMembers(Number(value));
          }}
        />
      </div>

      <div className="atc-row atc-row--light-bg">
        <Label
          label={step2_feeperyear.label}
          description={step2_feeperyear.description}
          tooltip={step2_feeperyear.tooltip}
        />
        <NumberFormat
          className="at-input at-input--border"
          thousandSeparator={"."}
          decimalSeparator={","}
          value={fee}
          onValueChange={values => {
            const { value } = values;
            setFee(Number(value));
          }}
        />
      </div>
      {extraFieldAtoms.map((atom, index) => {
        return (
          <ExtraField
            key={atom.toString()}
            atom={atom}
            index={index}
            delete={() => removeExtraField(atom)}
          />
        );
      })}

      <div
        className="at-add-row at-add-row"
        onClick={() =>
          setExtraFields(prevExtraFields => [
            ...prevExtraFields,
            {
              title: `Extra Income ${extraFieldAtoms.length + 1}`,
              value: null
            }
          ])
        }
      >
        <img
          src={
            window["mttFinancialAnalysisToolAssets"]?.plusIcon ??
            "/wp-content/themes/ulandssekretariatet/assets/img/icons/plus-icon.svg"
          }
          alt="Add row icon"
          className="at-add-row__image"
        />
        <span className="at-add-row__text">{step2_addextra_string}</span>
      </div>
      <p
        className="at-text-bottom"
        dangerouslySetInnerHTML={{ __html: step2_bottom_text }}
      />
      <div className="atc-button-group atc-button-group--border-top">
        <button className="button white" onClick={prev}>
          {back_string}
        </button>
        <button className="button red" onClick={next}>
          {next_string}
        </button>
      </div>
    </>
  );
}
